import styled from 'styled-components';

import colors from '~/styles/colors';
import grid from '~/styles/grid';

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  cursor: pointer;
`;

export const CollapseHeader = styled.div`
  background: ${colors.primary};
  color: ${colors.white};
  font-size: 12px;
  border-radius: 5px 5px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px 0 ${grid.sm};
  margin: 0 ${grid.lg};
`;

export const CollapseContent = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  gap: ${grid.sm};
  box-shadow: -3px 0px 6px #00000029;
  border-radius: 10px 10px 0px 0px;
  padding: ${grid.lg};
`;

export const Subtitle = styled.div`
  display: flex;
  align-items: center;
  color: #999999;

  img {
    position: absolute;
    height: ${grid.md};
    width: auto;
  }

  p {
    margin-left: ${grid.lg};
  }
`;

export const SubtitleIcon = styled.div`
  display: flex;
  align-items: center;
  gap: ${grid.xs};
`;

export const SubtitleSpan = styled.span``;
